import React, { useEffect } from 'react';
import Autocomplete1, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { NameTextField } from '../../../../../../styling/Styles';
import { checkIfEmpty, findCombinationIndex } from '../../../../../../validations/validations';

const testInvalidCharacters = (str) => /[\W_]+/.test(str);

/*
This component displays the autocomplete mechanim.It contains a textfield that when we insert inputs then it auto suggests in a
dropdown list all the already used options in this input.
*/
const AutoComplete = (props) => {
  const {
    annotationName,
    setAnnotationName,
    newSelected,
    annotationType,
    entity,
    clickedEdit,
    selectedProject,
    setAttributeParam,
    setValueParam,
    setLogicalOperatorParam,
    setComparisonOperatorParam,
    setAnnotationType,
    setEntity,
    setEntityName,
    setAnnotationTable,
    setAttributeType,
    setAttributeTypeService,
    setCustomAttributeType,
    setNewSelected,
    setFunctionName,
    setServiceSelectedAttr
  } = props;

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);

  useEffect(() => {
    if (clickedEdit === true) {
      const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];

      if (
        tempData !== undefined &&
        tempData.annotations !== undefined &&
        tempData.annotations[0] !== undefined &&
        tempData.annotations[0].combinations !== undefined
      ) {
        const tempOptions = [];

        tempData.annotations[0].combinations.forEach((combination) => {
          tempOptions.push(combination.annotationName);
        });
        setOptions(tempOptions);
      }
    }
  }, [clickedEdit]);

  const handleOpen = () => {
    if (annotationName.length > -1) {
      setOpen(true);
    }
  };

  const updateCombination = (newInputValue) => {
    setAnnotationName(newInputValue);

    const indexCombination = findCombinationIndex(newInputValue, selectedProject);

    const combination = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0]
      .combinations[indexCombination];

    setAnnotationType(combination.annotationType);
    setEntity(combination.annotationLink);
    setEntityName('');
    setAnnotationTable(combination.annotationTable);
    if(combination.attributeParam){
      setAttributeParam(combination.attributeParam);
    }
    if(combination.valueParam){
      setValueParam(combination.valueParam);
    }
    if(combination.logicalOperatorParam){
      setLogicalOperatorParam(combination.logicalOperatorParam);
    }
    if(combination.comparisonOperatorParam){
      setComparisonOperatorParam(combination.comparisonOperatorParam);
    }
    setAttributeType(combination.attributeType);
    setAttributeTypeService(combination.attributeTypeService);
    setCustomAttributeType(combination.customAttributeType);
    setFunctionName(combination.method);
    setServiceSelectedAttr(combination.serviceAttr);
    setNewSelected(false);
  };

  const handleInputChange = (event, newInputValue) => {
    if (findCombinationIndex(newInputValue, selectedProject) === -1) {
      setAnnotationName(newInputValue);
    } else {
      updateCombination(newInputValue);
    }

    if (newInputValue.length > -1) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option
  });

  const hasError = () => {
    if (
      checkIfEmpty(annotationName) === true &&
      (newSelected === true ||
        (newSelected === false && entity !== 'none') ||
        annotationType !== 'none')
    )
      return true;
    if (testInvalidCharacters(annotationName)) return true;
    return false;
  };

  const errorText = () => {
    if (
      checkIfEmpty(annotationName) === true &&
      (newSelected === true ||
        (newSelected === false && entity !== 'none') ||
        annotationType !== 'none')
    )
      return 'Annotation name empty';
    if (testInvalidCharacters(annotationName)) return 'No space or special characters (e.g. -,_,)';
    return null;
  };

  return (
    <Autocomplete1
      id="free-solo-demo"
      open={open}
      onOpen={handleOpen}
      onClose={() => setOpen(false)}
      inputValue={annotationName}
      onInputChange={handleInputChange}
      filterOptions={filterOptions}
      options={options}
      getOptionLabel={(option) => option}
      clearOnBlur={false}
      renderInput={(params) => (
        <NameTextField
          {...params}
          id="annotationNameInput"
          placeholder=" Annotation name"
          error={hasError()}
          helperText={errorText()}
        />
      )}
      ListboxProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
    />
  );
};

export default AutoComplete;
